import {
  SET_COUNTRIES, SET_TAGS, SET_MACROS
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
  [SET_TAGS](state, tags) {
    state.tags = tags;
  },
  [SET_MACROS](state, macros) {
    state.macros = macros;
  }
};